import { SELECTED_CHAIN_KEY } from '../constants'

interface SelectedChain {
  chainId?: string;
  chainName?: string;
  chainUseQrcode?: boolean;
  chainUsePromoter?: boolean;
}

export default (): SelectedChain => {
  try {
    return JSON.parse(localStorage.getItem(SELECTED_CHAIN_KEY) || '{}')
  } catch {
    return {}
  }
}
